import { Store, Module, ActionContext } from 'vuex'
import _ from 'lodash';
import ListModule from './list-module'
import ListState from './list-state'
import PurchaseOrderFileLine from '../entities/purchase-order-file-line'
import Ajax from '../../lib/ajax'
import PageResult from '@/store/entities/page-result';
import util from '@/lib/util';
import appconst from './../../lib/appconst';

interface PurchaseOrderImportState extends ListState<PurchaseOrderFileLine> {
    itemsImported: Array<PurchaseOrderFileLine>,
    countItems: number,
    countImportedItems: number
}
class PurchaseOrderImportModule extends ListModule<PurchaseOrderImportState, any, PurchaseOrderFileLine>{
    state = {
        totalCount: 0,
        currentPage: 1,
        pageSize: 10,
        list: new Array<PurchaseOrderFileLine>(),
        loading: false,
        itemsImported: new Array<PurchaseOrderFileLine>(),
        countItems: 0,
        countImportedItems: 0
    }
    actions = {
        async getAll(context: ActionContext<PurchaseOrderImportState, any>, payload: any) {
            context.state.loading = true;
            let reponse = await Ajax.get('/api/services/app/PoFile/GetAll', { params: payload.data });
            context.state.loading = false;
            let page = reponse.data.result as PageResult<PurchaseOrderFileLine>;
            context.state.totalCount = page.totalCount;
            context.state.list = page.items;
        },
        async uploadImportPurchaseOrderFile(context: ActionContext<PurchaseOrderImportState, any>, data: any) {
            let reponse = await Ajax.post('/api/services/app/PoFile/ImportPos', data);
            return reponse.data.result;
        },
        async export(context:ActionContext<PurchaseOrderImportState,any>,payload:any){
            window.open(`${appconst.remoteServiceBaseUrl}import/exportImportPos/`+payload.data, "_blank");    
        }
    };
    mutations = {
        setCurrentPage(state: PurchaseOrderImportState, page: number) {
            state.currentPage = page;
        },
        setPageSize(state: PurchaseOrderImportState, pagesize: number) {
            state.pageSize = pagesize;
        },
        setCountItems(state: PurchaseOrderImportState, count: number) {
            state.countItems = count;
        },
        setCountImportedItems(state: PurchaseOrderImportState, count: number) {
            state.countImportedItems = count;
        },
        processNotifier(state: PurchaseOrderImportState, payload: any) {
            if (payload.data != null) {
                if (payload.data.data != undefined && payload.data.data != null) {
                    let purchaseOrderLines = payload.data.data as Array<PurchaseOrderFileLine>;
                    var itemsImported = _.clone(state.itemsImported);
                    itemsImported= purchaseOrderLines.concat(itemsImported);
                    state.itemsImported = Object.freeze(itemsImported);
                }
                if (payload.data.countPo != undefined && payload.data.countPo != null && payload.data.countPo > 0) {
                    state.countItems = payload.data.countPo as number;
                }
                if (payload.data.poImported != undefined && payload.data.poImported != null && payload.data.poImported > 0) {
                    state.countImportedItems = payload.data.poImported as number;
                }
            }
        },
        resetList(state: PurchaseOrderImportState) {
            state.itemsImported = new Array<PurchaseOrderFileLine>();
        },
        pageChangeItemsImported(state: PurchaseOrderImportState) {
            state.list = util.pagingItems(state.itemsImported, state.pageSize, state.currentPage);
        }
    }
}
const purchaseOrderImportModule = new PurchaseOrderImportModule();
export default purchaseOrderImportModule;